import type { ReactNode } from "react";

export function TrustCallout({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <aside className="trust" role="note">
      <div className="trust__mark" aria-hidden>
        ✓
      </div>
      <div className="trust__body">
        <div className="trust__title">{title}</div>
        <div className="trust__text">{children}</div>
      </div>
    </aside>
  );
}
